import React, { useContext, useState } from "react";
import styled from "styled-components";
import { getCookie } from "../../../modules/utils/cookie";
import { ListContainer } from "./AccountMerge";
import { Header } from "./Header";
import MergeInfo from "./MergeInfo";
import { maxLengthCheck } from "../../common/maxLengthCheck/maxLengthCheck";
import { _O } from "../../../modules/utils";
import { AppContext } from "../../../components/AppProvider";
import { CustomConfirmLayer } from "../../../components/UI/Dialog";
import { closeLayerFn, openLayerFn } from "../../Layout";

export const PhoneCerti = (props) => {
  const { userinfo } = useContext(AppContext);

  const [dialog, setDialog] = useState({
    type: "check",
    title: "계정정보확인",
    msg: '계정정보와 다른 휴대폰 번호를 입력하셨습니다 <br /> 정보보호를 위해 본인 폰에서 통합하시길 권장합니다 <br /> 단, 전화번호가 변경된 경우 "내 정보 보기" 에서 "휴대전화" 수정 후 이용하세요',
    msg2: "",
    data: {},
  });

  const setTrgtUserToken = () => {
    _O.Open(
      "/membership/certi/MERGE/" + props.match.params.returnTarget + "/" + $("#phoneNumber").val()
    );
  };

  const checkPhoneNumber = () => {
    if (userinfo.userPhone == $("#phoneNumber").val()) {
      _O.Open("/membership/certi/MERGE/" + props.match.params.returnTarget);
    } else {
      openLayerFn($("#cstmCnfmLayer"));
    }
  };

  return (
    <ContainerWhite>
      <Header />
      <Title>계정통합</Title>

      <div style={{ width: "100%" }}>
        <ListContainer>
          <TextDiv>
            <TextTitle>통합계정</TextTitle>
            <TextData>{getCookie("userId")}</TextData>
          </TextDiv>
        </ListContainer>
      </div>

      <MergeInfo />

      <div>
        <Title>휴대폰 인증</Title>
        <TextArea>
          <TextP>인증번호를 받으실 휴대폰번호를 입력하세요</TextP>
        </TextArea>

        <div style={{ margin: "0px 16px", border: "1px solid #d0d0d0", borderRadius: "6px" }}>
          <input
            type="number"
            pattern="\d*"
            id="phoneNumber"
            placeholder="휴대폰 번호를 입력하세요"
            onChange={(e) => maxLengthCheck(11, e)}
            style={{ border: "none", borderRadius: "8px", padding: "16px" }}
          />
        </div>
      </div>

      <BottomBtn onClick={() => checkPhoneNumber()}>확인</BottomBtn>
      <CustomConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        msg2={dialog.msg2}
        handleConfirmCB={() => _O.Open("/mp/myInfo/view")}
        handleConfirmCBText={"수정하기"}
        handleCancelCB={() => closeLayerFn($("#cstmCnfmLayer"))}
        handleCancelCBText={"닫기"}
        setCookieBtn={false}
        textAlign="left"
      />
    </ContainerWhite>
  );
};

export const ContainerWhite = styled.div`
  background: white;
`;

export const Title = styled.div`
  margin: 37px 16px 0px 16px;
  color: #000;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const BottomBtn = styled.div`
  display: flex;
  height: 52px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  align-self: stretch;

  border-radius: 6px;
  border: 1px solid #333;
  background: #333;

  color: #fff;
  font-family: Malgun Gothic;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  margin: 0 20px;
  bottom: 24px;
  position: absolute;
  width: calc(100% - 40px);
`;

const TextDiv = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 16px;
  border-radius: 6px;
  background: #fafafa;
`;

const TextTitle = styled.div`
  color: #888;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

const TextData = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

const TextArea = styled.div`
  margin: 16px;
`;

const TextP = styled.div`
  color: #898989;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
